import MLIcon from '../../../../MLIcon/MLIcon';
import s from './SearchBar.module.css';

export const SearchBar = ({
  searchTerm,
  placeholder,
  className,
  onChange,
  onReset,
  onFocus,
}) => {
  return (
    <div
      className={`${s.searchContainer} ${className}`}
      data-test-id="individual-student-gb-assignment-search-bar"
    >
      <input
        type="text"
        className={s.searchInput}
        placeholder={placeholder}
        value={searchTerm}
        onChange={onChange}
        onFocus={onFocus}
        aria-label={placeholder}
      />

      {searchTerm ? (
        <MLIcon
          onClick={onReset}
          className={s.xIcon}
          type="x"
          viewBox="0 0 24 24"
          role="presentation"
        />
      ) : (
        <MLIcon
          className={s.searchIcon}
          type="search"
          viewBox="0 0 24 24"
          role="presentation"
        />
      )}
    </div>
  );
};
